export const geolocationHandler = callbackHandler => {
  if (navigator.geolocation) {
    return navigator.geolocation;
  }
  console.log('Geolocation is not supported by this browser.');
  callbackHandler();
};

export const setLocationLocalStorage = (key, data) => {
  localStorage.setItem(key, data);
};

export const getLocationLocalStorage = key => {
  try {
    return JSON.parse(localStorage.getItem(key)) || null;
  } catch (e) {
    return null;
  }
};
